import React from 'react'

export const PageHeading: React.FC<{heading: string}> = ({heading}) => {
  return (
    <p className="font-semibold text-primary text-[22px] leading-[26px]">
      {heading}
    </p>
  )
}
